// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_NonEmpty_CodeUnits from "../Data.String.NonEmpty.CodeUnits/index.js";
import * as Data_String_NonEmpty_Internal from "../Data.String.NonEmpty.Internal/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Parsing_Combinators from "../Parsing.Combinators/index.js";
import * as Parsing_String from "../Parsing.String/index.js";
import * as Parsing_String_Basic from "../Parsing.String.Basic/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var alt = /* #__PURE__ */ Control_Alt.alt(Parsing.altParserT);
var map = /* #__PURE__ */ Data_Functor.map(Parsing.functorParserT);
var IPv6Address = function (x) {
    return x;
};
var unsafeToString = function (v) {
    return "[" + (v + "]");
};
var unsafeFromString = IPv6Address;
var showIPv6Address = {
    show: function (v) {
        return "(IPv6Address.unsafeFromString " + (show(v) + ")");
    }
};
var parser = /* #__PURE__ */ (function () {
    var ipv6Char = alt(Parsing_String_Basic.hexDigit)(alt(Parsing_String["char"](":"))(Parsing_String["char"](".")));
    return Parsing_Combinators.withErrorMessage(map(IPv6Address)(Control_Apply.applyFirst(Parsing.applyParserT)(Control_Apply.applySecond(Parsing.applyParserT)(Parsing_String["char"]("["))(map(Data_String_NonEmpty_Internal.joinWith(Data_List_Types.foldableList)(""))(Data_List.someRec(Parsing.monadRecParserT)(Parsing.alternativeParserT)(map(Data_String_NonEmpty_CodeUnits.singleton)(ipv6Char)))))(Parsing_String["char"]("]"))))("IPv6 address");
})();
var ordIPv6Address = Data_Ord.ordString;
var eqIPv6Address = Data_Eq.eqString;
export {
    unsafeFromString,
    unsafeToString,
    parser,
    eqIPv6Address,
    ordIPv6Address,
    showIPv6Address
};
